import OrderReviewTotal from "./OrderReviewTotal.vue";

export {OrderReviewTotal}
export default OrderReviewTotal
